module.exports = __webpack_public_path__ + "img/corporate_fare.37e9887b.svg";